module.exports = __webpack_public_path__ + "media/images/publish_icon-1db8403342c9a976fe94485ea3d8b99f.png";